import { ActionConstants } from "../constants";

const initialState = {
  changeOrdersList: [],
  changeOrderData: null,
  changeOrderStatuses: [],
  totalCount: 0,
  loading: true,
  status: "success",
  text: "",
  showSnackbar: false,
};

const change_orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionConstants.CREATE_CHANGE_ORDER_SUCCESS:
      return {
        ...state,
        showSnackbar: false,
      };
    case ActionConstants.CHANGE_ORDER_GET_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        changeOrdersList: action.payload.changeOrdersList,
        totalCount: action.payload.totalCount,
      };
    case ActionConstants.CHANGE_ORDER_GET_BY_ID:
      return {
        ...state,
        loading: false,
      };
    case ActionConstants.CHANGE_ORDER_GET_BY_ID_SUCCESS:
      return {
        ...state,
        changeOrderData: action.payload,
      };
    case ActionConstants.CLEAR_CHANGE_ORDER_DATA:
      return {
        ...state,
        changeOrderData: null,
      };
    case ActionConstants.CHANGE_ORDER_STATUS_GET_ALL_SUCCESS:
      return {
        ...state,
        changeOrderStatuses: action.payload,
      };
    default:
      return state || {};
  }
};

export default change_orderReducer;
